<template>
  <!-- Main sidebar -->
  <div
    class="sidebar sidebar-dark sidebar-main sidebar-expand-md sidebar-menu"
    @mouseenter="showLeft = true"
    @mouseleave="showLeft = false"
  >
    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
      <a
        href="#"
        class="sidebar-mobile-main-toggle"
      >
        <i class="icon-arrow-left8" />
      </a>
      Navigation
      <a
        href="#"
        class="sidebar-mobile-expand"
      >
        <i class="icon-screen-full" />
        <i class="icon-screen-normal" />
      </a>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- Sidebar content -->
    <div
      class="sidebar-content"
    >
      <!-- Main navigation -->
      <div class="card card-sidebar-mobile">
        <ul
          class="nav nav-sidebar pt-0"
          data-nav-type="accordion"
        >
          <li
            class="nav-item"
          >
            <a
              @click="!disableBtnGoBack ? backToGoSaas() : ''"
              class="d-flex nav-link"
              :style="disableBtnGoBack ? 'cursor: not-allowed;' : 'cursor: pointer;'"
            >
              <i
                class="fal fa-arrow-circle-left d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </a>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'chat.all' }"
              class="d-flex nav-link"
            >
              <i
                class="fas fa-comments d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('facebook')"
          >
            <router-link
              :to="{ name: 'chat.messenger' }"
              class="d-flex nav-link"
            >
              <i
                class="icon-messenger d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>

          <li
            class="nav-item"
            v-show="checkIntegratedChannel('line')"
          >
            <router-link
              :to="{ name: 'chat.line' }"
              class="d-flex nav-link"
            >
              <i
                class="icon-line d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('tiktok')"
          >
            <router-link
              :to="{ name: 'chat.tiktok' }"
              class="d-flex nav-link"
            >
              <i
                class="fab fa-tiktok-v2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('shopee')"
          >
            <router-link
              :to="{ name: 'chat.shopee' }"
              class="d-flex nav-link"
            >
              <i
                class="fas fa-shoppee d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('lazada')"
          >
            <router-link
              :to="{ name: 'chat.lazada' }"
              class="d-flex nav-link"
            >
              <i
                class="fas fa-lazada d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('instagram')"
          >
            <router-link
              :to="{ name: 'chat.direct-message' }"
              class="d-flex nav-link"
            >
              <i
                class="icon-direct-message d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'customer' }"
              class="d-flex nav-link"
            >
              <i class="fas fa-users d-flex justify-content-start align-items-center" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'reports' }"
              class="d-flex nav-link"
            >
              <i class="fas fa-analytics d-flex justify-content-start align-items-center" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'settings' }"
              class="d-flex nav-link"
            >
              <i
                class="fas fa-gear d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
            </router-link>
          </li>
        </ul>
      </div>
      <!-- /main navigation -->
    </div>
    <!-- /sidebar content -->
    
    <div
      class="sidebar-menu-autohide"
      :class="showLeft || $parent.hoverLogo ? 'sidebar-menu-autohide-show' : 'sidebar-menu-autohide-hide'"
      @mouseenter="showLeftMenu()"
      @mouseleave="hideLeftMenu()"
    >
      <div class="logo-content pl-3">
        <router-link
          to="/chat/all"
          class="d-inline-block"
        >
          <img
            :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo')"
            alt=""
            class="logo logo-gochat-beta"
          >
        </router-link>
      </div>

      <div class="w-100">
        <ul
          class="nav nav-sidebar w-100 pt-0"
          data-nav-type="accordion"
        >
          <li
            class="nav-item"
          >
            <a
              @click="!disableBtnGoBack ? backToGoSaas() : ''"
              class="d-flex nav-link pl-3"
              :style="disableBtnGoBack ? 'cursor: not-allowed;' : 'cursor: pointer;'"
            >
              <i
                class="fal fa-arrow-circle-left mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Back To GoSell") }}</span>
              <div
                v-if="disableBtnGoBack"
                class="spinner-border spinner-border-sm text-light ml-2"
                role="status"
              >
                <span class="sr-only">{{ $t("Loading...") }}</span>
              </div>
            </a>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'chat.all' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="fas fa-comments mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("All") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('facebook')"
          >
            <router-link
              :to="{ name: 'chat.messenger' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="icon-messenger mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Messenger") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('line')"
          >
            <router-link
              :to="{ name: 'chat.line' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="icon-line mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Line") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('tiktok')"
          >
            <router-link
              :to="{ name: 'chat.tiktok' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="fab fa-tiktok-v2 mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Tiktok") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('shopee')"
          >
            <router-link
              :to="{ name: 'chat.shopee' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="fas fa-shoppee mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Shopee") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('lazada')"
          >
            <router-link
              :to="{ name: 'chat.lazada' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="fas fa-lazada mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Lazada") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
            v-show="checkIntegratedChannel('instagram')"
          >
            <router-link
              :to="{ name: 'chat.direct-message' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="icon-direct-message mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Direct Message") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'customer' }"
              class="d-flex nav-link pl-3"
            >
              <i class="fas fa-users mr-2 d-flex justify-content-start align-items-center" />
              <span>{{ $t("Customers") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'reports' }"
              class="d-flex nav-link pl-3"
            >
              <i class="fas fa-analytics mr-2 d-flex justify-content-start align-items-center" />
              <span>{{ $t("Reports") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'settings' }"
              class="d-flex nav-link pl-3"
            >
              <i
                class="fas fa-gear mr-2 d-flex justify-content-start align-items-center"
                style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
              />
              <span>{{ $t("Settings") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- /main sidebar -->
  <!-- /main sidebar -->
</template>

<script>
import { mapGetters } from "vuex";
import { USER } from "@/vuex-store/types";
import Api from "@/services/endpoint/central.service";
import Cookies from 'js-cookie';

export default {
  name: "LeftMenu",
  data() {
    return {
      showLeft: false,
      channels: [],
      filterChatType: "",
      disableBtnGoBack: false,
    };
  },
  watch: {
    "$store.state.channels"() {
      this.loadChatPages = true;
      const onlyUnique = (value, index, array) => {
        return array.indexOf(value) === index;
      }
      this.$store.state.channels.map(page => {
        if (page.integration_name) this.channels.push(page.integration_name)
      })
      this.channels = this.channels.filter(onlyUnique);
      this.loadChatPages = false;
    }
  },
  computed: {
    ...mapGetters({
      user: USER,
    }),
  },
  methods: {
    showLeftMenu() {
      this.showLeft = true;
    },
    hideLeftMenu() {
      this.showLeft = false;
    },
    checkIntegratedChannel(ch) {
      let isShow = false;
      isShow = this.channels.includes(ch);
      return isShow;
    },
    backToGoSaas() {
      this.disableBtnGoBack = true;
      if (Cookies.get("callbackUrl"))
        location.href = Cookies.get("callbackUrl");
      // + "/app/integrations?integration_group_id=5";
      else if (process.env.GOSAAS_BASE_URL) location.href = process.env.GOSAAS_BASE_URL;
      setTimeout(() => {
        this.disableBtnGoBack = false;
      }, 500);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/web/template/LeftMenu.vue